import { useMemo } from "react";
import type { CustomerDetails } from "components/job/JobTable/Customer/types";
import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface CustomerPropsHook {
  searchWords: string[];
  name: string;
  contact: string;
  address: string;
}

export default function useCustomerProps(customerDetails: CustomerDetails) {
  const [query] = useQuery("jobs");
  const searchWords = useSearchWords(query);

  const name = useMemo(() => {
    if (!customerDetails?.name) return "No name added";
    if (/^\s*$/.test(customerDetails?.name)) return "No name added";
    return customerDetails?.name;
  }, [customerDetails]);

  const contact = useMemo(() => {
    const email = customerDetails?.email;
    const phone = customerDetails?.phone;
    return [email, phone].filter((value) => value).join(", ");
  }, [customerDetails]);

  const address = useMemo(() => {
    const line1 = customerDetails?.addressLine1;
    const postCode = customerDetails?.postCode;
    const city = customerDetails?.city;
    return [line1, postCode, city].filter((value) => value).join(", ");
  }, [customerDetails]);

  return {
    searchWords,
    name,
    contact,
    address,
  };
}
